import { LightningElement } from "lwc";

export default class RecordHome extends LightningElement {
  static renderMode = `light`;
}
